export enum SelectMode {
  multiple = 'multiple',
  tags = 'tags'
}
